import PropTypes from 'prop-types';

const ButtonSimplePropType = {
  children: PropTypes.string,
  buttonStyle: PropTypes.oneOf(['fill', 'stroke', 'transparent']),
  mini: PropTypes.bool,
};

export default ButtonSimplePropType;
